export class Assert {
  static definied(value: unknown | undefined | null, message?: string): asserts value {
    if (value === undefined || value === null)
      throw new AssertionError(message ?? 'Was not defined!');
  }

  static above(value: number, limit: number, message?: string) {
    if (value < limit) return new AssertionError(message ?? `${value} is not above ${limit}`);
  }

  static truthy(value: unknown | undefined | null, message?: string): asserts value {
    if (!value) throw new AssertionError(message ?? 'Was not truthy!');
  }

  static isString(value: unknown | undefined | null, message?: string): asserts value is string {
    if (typeof value !== 'string') throw new AssertionError(message ?? `${value} is not a string!`);
  }
}

export class AssertionError extends Error {
  constructor(message: string) {
    super(message);
  }
}
